// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfiesTip_style_wrapper__zll8X","rotate":"SelfiesTip_style_rotate__xDYIL"};